import React from "react";

function Preloader() {
  return (
    <div className="preloader">
      <div className="loader-ripple">
        <div></div>
        <div></div>
      </div>
    </div>
  );
}

export default Preloader;
